export type PreviewReceiver = { id: number; name: string };
export type PreviewReceiverMapping = {
  frutic_receiver_name: string;
  exporter_receiver_id: number;
};
const normalize = (value: string | null | undefined) =>
  (value ?? '').trim().toUpperCase();

// Both lists must belong to the current exporter. A selected ID is authoritative;
// aliases are used only when shipment/extracted data has no official client ID.
export function resolveSettlementPreviewReceiver<T extends PreviewReceiver>(
  source: { exporter_receiver_id?: number | null; receiver?: string | null },
  receivers: T[],
  mappings: PreviewReceiverMapping[]
): T | null {
  if (source.exporter_receiver_id) {
    return (
      receivers.find(
        (receiver) => receiver.id === Number(source.exporter_receiver_id)
      ) ?? null
    );
  }
  const name = normalize(source.receiver);
  if (!name) return null;
  const mappedIds = new Set(
    mappings
      .filter((mapping) => normalize(mapping.frutic_receiver_name) === name)
      .map((mapping) => Number(mapping.exporter_receiver_id))
  );
  if (mappedIds.size > 1) return null;
  if (mappedIds.size === 1) {
    return receivers.find((receiver) => mappedIds.has(receiver.id)) ?? null;
  }
  const matches = receivers.filter(
    (receiver) => normalize(receiver.name) === name
  );
  return matches.length === 1 ? matches[0] : null;
}
